/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AmountObject } from '../../models/amount-object';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface ConvertAmountToSpecificCurrency$Params {
  amount: number;
  amountCurrencyUnit: string;
  amountCurrencyUnitToTransform: string;
  currencyUnitToTransformRateDate: string;
}

export function convertAmountToSpecificCurrency(
  http: HttpClient,
  rootUrl: string,
  params: ConvertAmountToSpecificCurrency$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<AmountObject>> {
  const rb = new RequestBuilder(rootUrl, convertAmountToSpecificCurrency.PATH, 'get');
  if (params) {
    rb.path('amount', params.amount, {});
    rb.path('amountCurrencyUnit', params.amountCurrencyUnit, {});
    rb.path('amountCurrencyUnitToTransform', params.amountCurrencyUnitToTransform, {});
    rb.path('currencyUnitToTransformRateDate', params.currencyUnitToTransformRateDate, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmountObject>;
    }),
  );
}

convertAmountToSpecificCurrency.PATH =
  '/service/v1/currencyKeys/convertAmountToSpecificCurrency/{amount}/{amountCurrencyUnit}/{amountCurrencyUnitToTransform}/{currencyUnitToTransformRateDate}';
